import React from 'react';
import './ServiceGrid.scss';

const ServicesGrid = () => {
  const services = [
    {
      title: "GIS Based Mapping",
      description: "Transforming geographical data into actionable insights through advanced GIS technology."
    },
    {
      title: "DMS Services",
      description: "Streamline your workflow with secure, efficient document management solutions for seamless information access and control."
    },
    {
      title: "IT Enabled Services",
      description: "Technology-driven solutions that leverage IT infrastructure for enhanced business operations."
    },
    {
      title: "Economic Analysis",
      description: "Data-driven economic research and statistical analysis for informed decision making."
    },
    {
      title: "Monitoring & Evaluation",
      description: "Comprehensive assessment services to measure program effectiveness and outcomes."
    }
  ];

  return (
    <section className="services-grid">
      <div className="container">
        <div className="grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <a href="/services" className="btn">Learn More</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;